import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

/**
 * 用於加載多個 i18n JSON 文件的自定義加載器
 */
export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = 'assets/i18n/',
    private files: string[] = []
  ) {}

  public getTranslation(lang: string): Observable<Record<string, unknown>> {
    const requests = this.files.map(file =>
      this.http
        .get(`${this.prefix}${lang}/${file}.json`)
        .pipe(catchError(() => of({})))
    );
    return forkJoin(requests).pipe(
      map(responseArr => Object.assign({}, ...responseArr))
    );
  }
}
